import {
  useQuery,
  keepPreviousData,
  UseQueryResult,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { AppointmentDetails } from "../types/appointment-types";
import { ApiEnvelope } from "../types/sdk-types";
import { getConfigObject } from "../utils/utils";
import { AppointmentControllerApi } from "../services";

interface GetAppointmentProps {
  appointmentUuid: string | undefined;
  providerGroupId: string;
  disabled?: boolean;
}

/**
 *
 * @author Shrinivas Mandhare
 */

export function useGetAppointment({
  appointmentUuid,
  providerGroupId,
  disabled,
}: GetAppointmentProps): UseQueryResult<
  ApiEnvelope<AppointmentDetails> | undefined,
  AxiosError
> {
  return useQuery({
    queryKey: ["appointment-list", appointmentUuid, providerGroupId],
    enabled:
      !disabled &&
      appointmentUuid !== undefined &&
      appointmentUuid !== null &&
      appointmentUuid !== "0",
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new AppointmentControllerApi(getConfigObject())
        .getAppointmentById(
          appointmentUuid!, //appointmentUuid
          providerGroupId! //xTENANTID
        )
        .then((it) => it?.data as ApiEnvelope<AppointmentDetails>),
  });
}
